import React from 'react'
import {
  Modifier,
  EditorState,
  RichUtils,
  getDefaultKeyBinding,
  convertFromRaw,
  convertToRaw
} from 'draft-js'

import Editor, { composeDecorators } from '@draft-js-plugins/editor'
import createImagePlugin from '@draft-js-plugins/image'
import createAlignmentPlugin from '@draft-js-plugins/alignment'
import createFocusPlugin from '@draft-js-plugins/focus'
import createResizeablePlugin from '@draft-js-plugins/resizeable'
import createBlockDndPlugin from '@draft-js-plugins/drag-n-drop'
import '@draft-js-plugins/alignment/lib/plugin.css'
import './text-editor.css'


// const imagePlugin = createImagePlugin()
// const plugins = [imagePlugin]

const focusPlugin = createFocusPlugin()
const resizeablePlugin = createResizeablePlugin()
const blockDndPlugin = createBlockDndPlugin()
const alignmentPlugin = createAlignmentPlugin()
// const { AlignmentTool } = alignmentPlugin

const decorator = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator,
  blockDndPlugin.decorator
)
const imagePlugin = createImagePlugin({ decorator })

const plugins = [
  blockDndPlugin,
  focusPlugin,
  alignmentPlugin,
  // resizeablePlugin,
  // imagePlugin,
]

/* eslint-disable */
const initialState = {
  entityMap: {},
  blocks: [
    {
      key: '9gm3s',
      text: '',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
}
/* eslint-enable */

class TextEditor extends React.Component {
  constructor(props) {
    super(props)
    //let contentState = stateFromHTML(props.value)
    let contentState;
    // if (props.value !== '' && JSON.parse(props.value) === 'object') {
    //   contentState = convertFromRaw(JSON.parse(props.value))
    // } else {
    //   contentState = convertFromRaw(initialState)
    // }
    contentState = convertFromRaw(initialState)


    this.state = {
      value: props.value,
      loaded: props.loaded,
      editorState: EditorState.createWithContent(contentState),
      isShow: false,
      url: '',
      firstRender: true,
    }
    this.editorRef = React.createRef()
    //this.focus = () => this.refs.editor.focus()
    this.onChange = (editorState) => {
      this.setState({ editorState })
      const rawContentState = convertToRaw(editorState.getCurrentContent());
      //convertToRaw(editorState)

      //const html = draftToHtml(rawContentState)
      //console.log(html)
      //const html = stateToHTML(editorState.getCurrentContent())    

      this.props.onChange(JSON.stringify(rawContentState))
    }

    this.handleKeyCommand = this._handleKeyCommand.bind(this)
    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this)
    this.toggleBlockType = this._toggleBlockType.bind(this)
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this)
    this.toggleCommon = this._toggleCommon.bind(this)

  }

  _handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      this.onChange(newState)
      return true
    }
    return false
  }

  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(e, this.state.editorState, 4 /* maxDepth */)
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState)
      }
      return
    }
    return getDefaultKeyBinding(e)
  }

  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType))
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle))
  }

  _toggleCommon(common) {

    if (common === 'img') {
      this.setState({
        ...this.state,
        isShow: true,
      })
    }
    const alignmentStyles = ['left', 'right', 'center'];
    if (alignmentStyles.includes(common)) {
      let styleForRemove = alignmentStyles.filter(style => style !== common);
      let currentContent = this.state.editorState.getCurrentContent();
      let selection = this.state.editorState.getSelection();
      let focusBlock = currentContent.getBlockForKey(selection.getFocusKey());
      let anchorBlock = currentContent.getBlockForKey(selection.getAnchorKey());
      let isBackward = selection.getIsBackward();

      let selectionMerge = {
        anchorOffset: 0,
        focusOffset: focusBlock.getLength(),
      };

      if (isBackward) {
        selectionMerge.anchorOffset = anchorBlock.getLength();
      }
      let finalSelection = selection.merge(selectionMerge);
      let finalContent = styleForRemove.reduce((content, style) => Modifier.removeInlineStyle(content, finalSelection, style), currentContent);
      let modifiedContent = Modifier.applyInlineStyle(finalContent, finalSelection, common);
      // const html = stateToHTML(modifiedContent.getCurrentContent())
      // console.log(html)

      const nextEditorState = EditorState.push(this.state.editorState, modifiedContent, 'change-inline-style');
      this.onChange(nextEditorState);
      //this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'right'))
    }

  }


  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      if (this.props.value !== '') {       
        let contentState = convertFromRaw(JSON.parse(this.props.value))
        const state = EditorState.createWithContent(contentState)
        this.setState({
          editorState: state,
          loaded: true,
        })
      }

    }
  }


  render() {
    const { editorState } = this.state

    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor'
    var contentState = editorState.getCurrentContent()

    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder'
      }
    }

    return (
      <div key='1'>
        <div className='RichEditor-root'>
          <BlockStyleControls editorState={editorState} onToggle={this.toggleBlockType} />
          <InlineStyleControls editorState={editorState} onToggle={this.toggleInlineStyle} />
          <CommonControls editorState={editorState} onToggle={this.toggleCommon} />
          <div className={className} onClick={this.focus}>
            <Editor
              blockStyleFn={getBlockStyle}
              customStyleMap={styleMap}
              editorState={editorState}
              handleKeyCommand={this.handleKeyCommand}
              keyBindingFn={this.mapKeyToEditorCommand}
              onChange={this.onChange}
              placeholder=''
              ref={this.editorRef}
              spellCheck={true}
              plugins={plugins}
            />
          </div>
        </div>
        {/* <AlignmentTool /> */}
        {/* <ImageAdd
          editorState={this.state.editorState}
          onChange={this.onChange}
          modifier={imagePlugin.addImage}
        /> */}

      </div>
    )
  }
}

// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
  right: {
    textDecoration: 'line-through',
  },
}

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote'
    default:
      return null
  }
}

class StyleButton extends React.Component {
  constructor() {
    super()
    this.onToggle = (e) => {
      e.preventDefault()
      this.props.onToggle(this.props.style)
    }
  }

  render() {
    let className = 'RichEditor-styleButton'
    if (this.props.active) {
      className += ' RichEditor-activeButton'
    }
    if (this.props.common) {
      className = 'RichEditor-styleButton'
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    )
  }
}

const BLOCK_TYPES = [
  { label: 'H1', style: 'header-one' },
  { label: 'H2', style: 'header-two' },
  { label: 'H3', style: 'header-three' },
  { label: 'H4', style: 'header-four' },
  { label: 'H5', style: 'header-five' },
  { label: 'H6', style: 'header-six' },
  { label: 'Blockquote', style: 'blockquote' },
  { label: 'UL', style: 'unordered-list-item' },
  { label: 'OL', style: 'ordered-list-item' },
  { label: 'Code Block', style: 'code-block' },
]

const BlockStyleControls = (props) => {
  const { editorState } = props
  const selection = editorState.getSelection()
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType()

  return (
    <div className='RichEditor-controls'>
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  )
}

var INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD' },
  { label: 'Italic', style: 'ITALIC' },
  { label: 'Underline', style: 'UNDERLINE' },
  { label: 'Monospace', style: 'CODE' },
]

const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle()

  return (
    <div className='RichEditor-controls'>
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  )
}

var COMMON_STYLES = [
  // { label: 'IMG', style: 'img' },
  // {label: 'Left', style: 'left'},
  // {label: 'Center', style: 'center'},
  // {label: 'Right', style: 'right'}
]


const CommonControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle()

  return (
    <div className='RichEditor-controls'>
      {COMMON_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          common={true}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  )
}


export default TextEditor
